import { render, staticRenderFns } from "./OnLt65SepLecNoHsaNoSsiGuidance.vue?vue&type=template&id=d082471a&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SurveyPartsabSummarySubguidance: require('/home/docker/code/frontend/components/survey/PartsabSummarySubguidance.vue').default,SurveyWhenToSignUpSubguidance: require('/home/docker/code/frontend/components/survey/WhenToSignUpSubguidance.vue').default,SurveyHowToSignUpPartsabSubguidance: require('/home/docker/code/frontend/components/survey/HowToSignUpPartsabSubguidance.vue').default,SurveyWatchOutForSubguidance: require('/home/docker/code/frontend/components/survey/WatchOutForSubguidance.vue').default,SurveyGettingCoverageAfterMedicareSubguidance: require('/home/docker/code/frontend/components/survey/GettingCoverageAfterMedicareSubguidance.vue').default})
